import { MeshReflectorMaterial, useVideoTexture } from "@react-three/drei";

const VideoTexture = ({src}:{src: string}) => {
  const texture = useVideoTexture(src);

  return (
    <MeshReflectorMaterial
      map={texture}
      toneMapped={false}
      resolution={2048}
      mixBlur={1}
      mixStrength={10}
      roughness={0.99}
      depthScale={1.1}
      minDepthThreshold={0.4}
      maxDepthThreshold={1.3}
      color="#469908"
      metalness={0.8}
      mirror={0}
    />
  );
};
export default VideoTexture;
